"use client"

import { Info } from "lucide-react"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "~/components/ui/popover"
import {
    type BadgeLevel,
    NewHostIcon,
    EngagedHostIcon,
    InFlowHostIcon,
} from "~/lib/facilitator-badges"



type InfoPopoverProps = {
    /** Highlight the current level */
    title: string,
    description: string
}

export function InfoPopover({ title, description }: InfoPopoverProps) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    className="inline-flex items-center justify-center p-0.5 rounded-full 
            text-neutral-900 hover:text-neutral-700  transition-colors"
                >
                    <Info className="h-3.5 w-3.5" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-80 p-4" align="start">
                <h3 className="text-sm font-semibold text-neutral-emphasis mb-3">{title}</h3>
                <div className="space-y-3">
                    <p className={"text-sm font-medium  text-neutral-emphasis"}>
                        {description}
                    </p>


                </div>
            </PopoverContent>
        </Popover >
    )
}
